module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-94.53177782.svg";